// extracted by css-extract-rspack-plugin
export default {"description":"Form__description--doZDo"};